// extracted by mini-css-extract-plugin
export default {"Content":"ContentStteper_Content__wP9xL"};